var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Texture, ImageLoader, RGBAFormat } from "three";
import { BASE_URL } from "../../html";
export const DEFAULT_PORTRAIT_IMAGE_RELATIVE_PATH = "img/avatars/defaultUserImageNew.png";
export const DEFAULT_PORTRAIT_IMAGE_PATH = `${BASE_URL}/${DEFAULT_PORTRAIT_IMAGE_RELATIVE_PATH}`;
class PortraitTextureService {
    constructor() {
        this.imageLoader = new ImageLoader();
        this.textureCache = new Map();
        this.assetDirectory = BASE_URL + "/img/avatars";
        this.defaultImagePath = DEFAULT_PORTRAIT_IMAGE_PATH;
        this.defaultImagePromise = new Promise((resolve) => {
            this.imageLoader.load(this.defaultImagePath, (image) => {
                resolve(image);
            }, (err) => {
                console.error("[renderer]", err);
            });
        });
    }
    getUserTexture(avatarUrl) {
        const resolvedAvatarUrl = avatarUrl.trim() === "" ? this.defaultImagePath : avatarUrl;
        let texture = this.textureCache.get(resolvedAvatarUrl);
        if (texture === undefined) {
            texture = new Texture();
            this.loadTexture(resolvedAvatarUrl, texture);
            this.textureCache.set(resolvedAvatarUrl, texture);
        }
        return texture;
    }
    loadTexture(url, texture) {
        this.imageLoader.load(url, (image) => {
            this.onImageLoaded(url, image, texture);
        }, undefined, () => __awaiter(this, void 0, void 0, function* () {
            const image = yield this.defaultImagePromise;
            this.onImageLoaded(this.defaultImagePath, image, texture);
            console.warn(`[renderer] Could not load avatar image from url "${url}", using a default image instead`);
        }));
    }
    onImageLoaded(_url, image, texture) {
        texture.image = image;
        texture.format = RGBAFormat;
        texture.needsUpdate = true;
    }
}
export const portraitTextureService = new PortraitTextureService();
